export const getQueryParams = () => new URLSearchParams(window.location.search);
